import React, { useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {
  ACTIVITY_EDITOR_VIEW, BUTTON,
  CHOOSE_FILE_TEXT,
  DOWNLOAD_SAMPLE_CSV_TEXT, GRADE_SCHEMA,
  IMPORT_QUESTION_MODAL_BODY_TEXT,
  IMPORT_QUESTION_MODAL_TITLE,
  IMPORT_QUESTIONS_TEXT,
  INVALID_IMPORT_TEXT,
  LEARN_MORE_LINK,
  LEARN_MORE_TEXT, LINK,
  MODAL_CANCEL_TEXT, MODAL_CLOSE_TEXT,
  MODAL_GO_BACK_TEXT,
  MODAL_IMPORT_TEXT,
  MODAL_NEXT_TEXT, QUESTION_TEXT,
  QUESTION_TYPES,
  SAMPLE_QUESTIONS,
  SEARCH_BTN,
  TEXTBOX,
  UPLOAD_CSV_FILE_TEXT,
  UPLOAD_MEDIA,
  USER_SETTINGS,
  VALIDATE_IMPORT_TEXT
} from "../../utils/constants";
import {
  fillFormatText,
  formatFileSize,
  getDefaultParticipationPoints, isParticipationPointEnabled,
  notifyError,
  notifySuccess
} from "../../utils/helpers";
import {
  initialQuestionData,
  questionNameToCode,
  addQuestion,
  questionCodeToName,
  getBlanks
} from "../../utils/questionUtils";
import { IMPORT_SUCCESS_MESSAGE, INVALID_CSV_ERROR,  UPLOAD_ONE_FILE_ERROR } from "../../utils/toast-message-constants";
import YuJaButton from "../standardization/YuJaButton";
import useMobileAccess from "../../hooks/useMobileAccess";
import { ReactComponent as UploadImage } from "../../images/upload_purple.svg";
import { ReactComponent as DeleteImage } from "../../images/feedbackFileDelete.svg";
import styles from "./QuestionProfiles.module.css";
import { YuJaTextBox } from "../standardization/YuJaTextBox";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import { updateQuestionType } from "../../utils/questionUpdate";
import FocusTrap from "../FocusTrap";
import {Button} from "@base-ui/react/button";

export default function ImportQuestionModal({
                                              setModalShow,
                                              show,
                                              questions,
                                              setQuestions,
                                              userSettings,
                                              gradeSchema=GRADE_SCHEMA.GRADED.key,
                                              setEditorView,
}) {
    const ref = useRef();
    const isNarrow = useMobileAccess(1100);
    const [file, setFile] = useState();
    const [next, setNext] = useState(false);
    const [fileName, setFileName] = useState(""); 
    const [fileSize, setFileSize] = useState(""); 
    const [keyword, setKeyword] = useState("");
    const [data, setData] = useState([]);
    const [importedData, setImportedData] = useState([]);
    const [validQuestions, setValidQuestions] = useState(0);
    const [invalidQuestions, setInvalidQuestions] = useState(0);

    const [array, setArray] = useState([]);

    const fileReader = new FileReader();

  const handleImport = (list) => {
    let questionsCopy = JSON.parse(JSON.stringify(questions));
    const size = questionsCopy.length;
    const lastQ = size ? questionsCopy[size - 1] : {};
    if (!lastQ.questionType && !!list.length) {
      questionsCopy.pop();
    }
    let curr_questions = questionsCopy; 
    list.forEach((item) => {
      const modifiedQuestion = {};
      modifiedQuestion.queTitle = item["Question Title"];
      modifiedQuestion.questionType = questionNameToCode(item["Question Type"]);
      modifiedQuestion.timeLimit = userSettings[USER_SETTINGS.QUESTION_DURATION];
      const { optionsMap, correctAnswers } = initialQuestionData(questionNameToCode(item["Question Type"]), userSettings, false);
      modifiedQuestion.optionsMap = optionsMap; 
      modifiedQuestion.correctAnswers = correctAnswers;
       if (item.Options && item["Question Type"] === QUESTION_TYPES.MCSS.description) {
        let MCoptionsMap = {};
        const optionsArray = item.Options.split(", ").map(option => option.trim());

        optionsArray.forEach((option, index) => {
          const key = String.fromCharCode(97 + index);
          if (item.Answer && option == item.Answer) {
            modifiedQuestion.correctAnswers = [key]; 
          }
          MCoptionsMap[key] = option;
        });
        modifiedQuestion.optionsMap = MCoptionsMap;
      }
      else if (item.Answer && item["Question Type"] === QUESTION_TYPES.TF.description) {
        if (item.Answer.toLowerCase() == "true" || item.Answer.toLowerCase() == "false" ) {
          modifiedQuestion.correctAnswers = item.Answer;
        }
      }
      else if (item.Answer && item["Question Type"] === QUESTION_TYPES.MH.description) {
        modifiedQuestion.correctAnswers = transformMatchingString(item.Answer);
      } 
      else if (item["Blank Pairs"] && item["Question Type"] === QUESTION_TYPES.FITB.description) {
        modifiedQuestion.correctAnswers = transformFITBString(item["Blank Pairs"]);
        if (Object.entries(modifiedQuestion.correctAnswers).length === 0) {
          let blanks = getBlanks(modifiedQuestion.queTitle, true);
          const newCorrectAnswers = {};
          for (const blankName of blanks) {
            newCorrectAnswers[blankName] = "";
          }
          modifiedQuestion.correctAnswers = newCorrectAnswers;
        }

      } else if (item["Question Type"] === QUESTION_TYPES.RK.description && item.Options) {
        const optionsArray = item.Options.split(", ").map(option => option.trim());
        modifiedQuestion.optionsMap = optionsArray;
      }
      modifiedQuestion.weightage = gradeSchema === GRADE_SCHEMA.UNGRADED.key
          ? 0
          : userSettings[USER_SETTINGS.QUESTION_POINTS];
      if (isParticipationPointEnabled(userSettings)) {
        modifiedQuestion.participationWeightage = gradeSchema === GRADE_SCHEMA.UNGRADED.key
            ? 0
            : getDefaultParticipationPoints(userSettings);
      }

      modifiedQuestion.getReadyTimeLimit = userSettings[USER_SETTINGS.QUESTION_COUNTDOWN];
      modifiedQuestion.entries = userSettings[USER_SETTINGS.QUESTION_ENTRIES];
      modifiedQuestion.serialNo = curr_questions.length + 1;
      modifiedQuestion.classResultDuration = userSettings[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION];
      curr_questions.push(modifiedQuestion);
    });
    setQuestions(curr_questions);
    notifySuccess(IMPORT_SUCCESS_MESSAGE);
    setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
    handleClose();
    };

    const transformMatchingString = (input) => {
      try {
      const cleanedInput = input.slice(1, -1);
    
      const pairs = cleanedInput.split(',');

      const result = pairs.map(pair => {
        const [premise, response] = pair.split(':');
        return response ? [premise.trim(), response.trim()] : [premise.trim()];
      });
    
      return result;
    } catch (e) {
      throw new Error("invalid format"); 
    }
    };

    const transformFITBString = (input) => {
      try {
        const cleanedInput = input.slice(1, -1);

        const pairs = cleanedInput.split(',').map(i => i.trim());

        const result = pairs.reduce((acc, pair) => {
          const [blank, answers] = pair.split(':').map(i => i.trim());
          const answersArray = answers.split('|').map(i => i.trim())
          acc[blank.trim()] = answersArray;
          return acc;
        }, {});

        return result;
      } catch (e) {
        console.log("invalid format", e)
        return {};
      }
    };


    const handleClose = () => {
      setModalShow(false); 
      setFile("");
      setArray([]);
      setNext(false);
      setFileName("");
      setFileSize(""); 
      setImportedData([]);
      setKeyword("");
      setData([]);
      setValidQuestions(0);
      setInvalidQuestions(0);
    }

    const handleBack = () =>{
      if(!next){
        setModalShow(false); 
        setFile("");
        setFileName("");
        setFileSize(""); 
        setImportedData([]);
        setKeyword("");
        setData([]);
        setValidQuestions(0);
        setInvalidQuestions(0);
      }
       else {
        setNext(false);
        setImportedData(data);
        setKeyword("");
       }
    };

    const handleOnChange = (e) => {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let validCount  = csvFileToArray(text);
        if (validCount == 0) {
          notifyError(INVALID_CSV_ERROR);
        }
        else {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
        setFileSize(e.target.files[0].size);
        }
        ref.current.value = '';
      };

      fileReader.readAsText(e.target.files[0]);
    };

    const validateRows = (rows) => {
      let invalidRowCount = 0;
      const validRows = [];
      rows.forEach(row => {
        let valid = true; 
        if (!row["Question Type"] || !row["Question Title"]) {
          invalidRowCount++;
          valid = false;
        } 
        if(valid && row["Question Type"]) {
          try {
            questionNameToCode(row["Question Type"]);
          } catch (e) {
            invalidRowCount++;
            valid = false
          }
        } 
        // if (valid && row["Question Type"] && pollType.toUpperCase() === POLL_TYPE.SURVEY && row["Question Type"] === QUESTION_TYPES.MH.description) {
        //   invalidRowCount++;
        //   valid = false
        // }
        // if (valid && pollType.toUpperCase() !== POLL_TYPE.SURVEY && pollType !== POLL_TYPE.ATTENDANCE && (row["Question Type"] === QUESTION_TYPES.RK.description || row["Question Type"] === QUESTION_TYPES.WC.description) ) {
        //   invalidRowCount++;
        //   valid = false
        // }
        if (valid && row["Question Type"] === QUESTION_TYPES.MH.description) {
          try { transformMatchingString(row.Answer);
          } catch (e) {
            invalidRowCount++;
            valid = false
          }
        // } else if (valid && pollType.toUpperCase() !== POLL_TYPE.SURVEY && pollType !== POLL_TYPE.ATTENDANCE && row["Question Type"] === QUESTION_TYPES.FITB.description) {
        //   try { 
        //     transformFITBString(row["Blank Pairs"]);
        //   } catch (e) {
        //     invalidRowCount++;
        //     valid = false
        //   }
        }
        if (valid) {
          validRows.push(row);
        }
      });
      setData(validRows);
      setImportedData(validRows);
    
      const validRowCount = rows.length - invalidRowCount;
      setValidQuestions(validRowCount);
      setInvalidQuestions(invalidRowCount); 
      return validRowCount; 
    };


    const handleExportFromModal = () => {
        const fileType = "application/octet-stream";
        const fileExtension = ".csv";
        const ws = XLSX.utils.json_to_sheet(SAMPLE_QUESTIONS);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }
    
        const data = new Blob([s2ab(csvOutput)], { type: fileType });
        FileSaver.saveAs(data, "Sample File" + fileExtension);
      };

      const dragOver = (e) => {
        e.preventDefault();
      };
    
      const dragEnter = (e) => {
        e.preventDefault();
      };
    
      const dragLeave = (e) => {
        e.preventDefault();
      };
    
      const fileDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files.length > 1) {
          notifyError(UPLOAD_ONE_FILE_ERROR);
          return;
        }
        fileReader.onload = function (event) {
          const text = event.target.result;
          let validCount = csvFileToArray(text);
          if (validCount == 0) {
            notifyError(INVALID_CSV_ERROR)
          } else {
          setFile(files[0]);
          setFileName(files[0].name);
          setFileSize(files[0].size);
          }
        };
        fileReader.readAsText(files[0]);
      };
    
      const handleOnSubmit = (e) => {
        e.preventDefault();
    
        if (file) {
          // fileReader.onload = function (event) {
          //   const text = event.target.result;
          //   csvFileToArray(text);
          // };
    
          // fileReader.readAsText(file);
          setNext(true);
        }
        else {
          notifyError("Please upload a file.");
        }
    }

    const csvFileToArray = string => {
      const csvRows = string.split('\n');
      const csvHeader = parseCSVRow(csvRows[0]);
    
      const array = csvRows.slice(1, -1).map(row => {
        const values = parseCSVRow(row);
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index];
          return object;
        }, {});
        return obj;
      });
    
      setArray(array);
      return validateRows(array);
    };
    
    const parseCSVRow = row => {
      const result = [];
      let inQuotes = false;
      let value = '';
    
      for (let i = 0; i < row.length; i++) {
        const char = row[i];
        if (char === '"' && row[i + 1] === '"') {
          // Handle escaped quotes within a quoted field
          value += '"';
          i++;
        } else if (char === '"') {
          // Toggle the inQuotes flag when encountering a quote character
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          // If not inside a quoted field, treat comma as field separator
          result.push(value.replaceAll("\r", "")
              .replaceAll("\n", "")
              .replaceAll("\t", ""));
          value = '';
        } else {
          // Otherwise, add the character to the current field
          value += char;
        }
      }
      result.push(value.replaceAll("\r", "")
          .replaceAll("\n", "")
          .replaceAll("\t", "")); // Add the last value
      return result;
    };
  


    return (
        <FocusTrap isOpened={show} setIsOpened={setModalShow} dataId={"import-question-modal"}>
          <Modal
              id="import-question-modal"
              show={show}
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              backdrop={true}
          >
            <ModalClose tabIndex={0} aria-label={MODAL_CLOSE_TEXT} role={BUTTON} onClick={handleClose}
                        className="modal-close"/>
            <Modal.Header
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
            >
              <Modal.Title as="h2" className="modal-title" id="contained-modal-title-vcenter">
                {IMPORT_QUESTIONS_TEXT}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {!next &&
                  <>
                    <div style={{fontSize: 14, display: "flex", gap: 2}}>
                      {UPLOAD_CSV_FILE_TEXT}
                      <div
                          tabIndex={0}
                          role={LINK}
                          aria-label={"Learn more about importing questions (opened in a new tab)"}
                          style={{textDecoration: "underline", color: "#006DC7", cursor: "pointer"}}
                          onClick={() => window.open(LEARN_MORE_LINK)}
                      > {LEARN_MORE_TEXT} </div>
                      .
                    </div>
                    <div style={{fontSize: 14, display: "flex", gap: 2, marginTop: 15}}>
                      {IMPORT_QUESTION_MODAL_BODY_TEXT}
                      <Button role={LINK} onClick={handleExportFromModal} style={{
                        color: "#42296E",
                        textDecoration: "underline",
                        cursor: "pointer",
                        marginLeft: 3
                      }}>{" Download template (2KB)"} </Button>
                    </div>

                    <div
                        className={"image-upload-container"}
                        onDragOver={dragOver}
                        onDragEnter={dragEnter}
                        onDragLeave={dragLeave}
                        onDrop={fileDrop}
                        onClick={(e) => ref.current.click(e)}
                        style={isNarrow ? {height: "auto", marginTop: 25} : {marginTop: 25}}
                    >
                      <div className="justify-content-center"
                           style={{display: "flex", alignItems: "center", gap: "10px", marginLeft: "0px", padding: 5}}>
                        <UploadImage width={40} height={40}/>
                        <p
                            tabIndex={0}
                            aria-label={UPLOAD_MEDIA}
                            role={TEXTBOX}
                            className={`${"drag-drop-text"} d-flex`}
                            style={{width: "auto", height: "100%", margin: 0, alignItems: "center", flexWrap: "wrap"}}
                        >
                          Drag & Drop or
                          <div style={{
                            color: "#006DC7",
                            textDecoration: "underline",
                            fontWeight: "700",
                            marginLeft: "5px",
                            marginRight: "5px"
                          }}> {CHOOSE_FILE_TEXT} </div>
                          to Upload
                        </p>
                        <input
                            ref={ref}
                            className="browse-box"
                            type="file"
                            accept={".csv"}
                            onChange={handleOnChange}
                            aria-label="upload image"
                        />
                      </div>
                    </div>
                    {fileName && <div style={{display: "flex", gap: "5px", fontSize: "14px", marginTop: "10px"}}>
                      <div style={{
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: "600px",
                        overflow: "hidden"
                      }}>{fileName}</div>
                      <div>[{formatFileSize(fileSize)}]</div>
                      <div style={{flex: 1, display: "flex", justifyContent: "end", cursor: "pointer"}}><DeleteImage
                          onClick={() => {
                            setFile("");
                            setFileName("");
                            setFileSize("")
                          }}/></div>
                    </div>}
                  </>
              }
              {
                  next && <>
                    <div style={{
                      fontSize: 14,
                      fontWeight: 400,
                      marginBottom: "15px",
                      color: "#000000"
                    }}> {fillFormatText(VALIDATE_IMPORT_TEXT, {ImportCount: validQuestions != "1" ? validQuestions + " questions" : validQuestions + " question"}) + (invalidQuestions != "0" ? fillFormatText(INVALID_IMPORT_TEXT, {UnimportCount: invalidQuestions != "1" ? invalidQuestions + " questions" : invalidQuestions + " question"}) : "")} </div>
                    <div className={styles.searchBox} style={{
                      margin: "0px 0px 20px 0px",
                      border: "1px solid #E4E4E4",
                      backgroundColor: "#FFFFFF",
                      height: 60,
                      borderRadius: "0.461rem",
                      padding: "0px 15px 0px 15px",
                      boxShadow: "0px 0px 4.5px 0px #0000001A"
                    }}>
                      <Form className={styles.searchBoxForm} onSubmit={e => e.preventDefault()}>
                        <YuJaTextBox
                            containerStyle={{marginRight: 15, height: 37, fontSize: 13}}
                            placeholder="Find by question title"
                            onChange={e => setKeyword(e.target.value)}
                            value={keyword}
                            before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                        >
                        </YuJaTextBox>

                        <YuJaButton aria-label={SEARCH_BTN} role={TEXTBOX} onClick={() => {
                          setImportedData(data.filter(item => {
                            return item["Question Title"] && item["Question Title"].toLowerCase().indexOf(keyword.toLowerCase()) > -1;
                          }));
                        }}>Search</YuJaButton>
                      </Form>
                    </div>
                    <div className={styles.importQuestionsPreviewTable}>
                      <span className={`${styles.header} ${styles.cell}`} style={{paddingLeft: 20}}>No</span>
                      <span className={`${styles.header} ${styles.cell}`}>Question Type</span>
                      <span className={`${styles.header} ${styles.cell}`}>{QUESTION_TEXT}</span>
                      {importedData.map((item, index) => (
                          <>

                            <span className={styles.cell} style={{paddingLeft: 20}}> {index + 1} </span>
                            <span className={styles.cell}> {item["Question Type"]}</span>
                            <span
                                className={styles.cell}
                                style={{overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}
                            >
                                {item["Question Title"]}
                              </span>
                          </>
                      ))}
                    </div>
                  </>
              }
            </Modal.Body>
            <Modal.Footer>
              <YuJaButton type="secondary"
                          onClick={handleBack}>{next === false ? MODAL_CANCEL_TEXT : MODAL_GO_BACK_TEXT}</YuJaButton>
              {next === false &&
                  <YuJaButton onClick={handleOnSubmit} disabled={validQuestions == 0}>{MODAL_NEXT_TEXT}</YuJaButton>}
              {next === true && <YuJaButton onClick={() => {
                handleImport(data)
              }}>{MODAL_IMPORT_TEXT}</YuJaButton>}
            </Modal.Footer>
          </Modal>
        </FocusTrap>
    );
}